import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=ca435f80&scoped=true&"
import script from "./pageList.vue?vue&type=script&lang=js&"
export * from "./pageList.vue?vue&type=script&lang=js&"
import style0 from "./pageList.vue?vue&type=style&index=0&id=ca435f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca435f80",
  null
  
)

export default component.exports